/**
 * Der Mismatch-Banner spricht den Nutzer in der ZIELsprache an — sonst liest ihn
 * genau der nicht, fuer den er gedacht ist. Deshalb muessen alle 6 Varianten zur
 * Laufzeit verfuegbar sein; die normalen Locale-Files liefern nur die Sprache des
 * laufenden Builds. Kleine Konstanten-Map, analog zu `trans.languages`.
 *
 * Wortgleich gehalten mit `whocan-website/src/scripts/language-banner-texts.ts`.
 */
export interface LanguageBannerText {
    message: string;
    switchLabel: string;
    dismissLabel: string;
}

export const LANGUAGE_BANNER_TEXTS: Record<string, LanguageBannerText> = {
    en: {
        message: 'This page is also available in English.',
        switchLabel: 'Switch to English',
        dismissLabel: 'Keep current language',
    },
    de: {
        message: 'Diese Seite gibt es auch auf Deutsch.',
        switchLabel: 'Zu Deutsch wechseln',
        dismissLabel: 'Bei der aktuellen Sprache bleiben',
    },
    es: {
        message: 'Esta página también está disponible en español.',
        switchLabel: 'Cambiar a español',
        dismissLabel: 'Mantener el idioma actual',
    },
    fr: {
        message: 'Cette page existe aussi en français.',
        switchLabel: 'Passer au français',
        dismissLabel: 'Conserver la langue actuelle',
    },
    it: {
        message: 'Questa pagina è disponibile anche in italiano.',
        switchLabel: "Passa all'italiano",
        dismissLabel: 'Mantieni la lingua attuale',
    },
    pt: {
        message: 'Esta página também está disponível em português.',
        switchLabel: 'Mudar para português',
        dismissLabel: 'Manter o idioma atual',
    },
};
